// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"EventsList_searchWrapper__2Ngg3"};